/**
 * Пороги плотности карты (Wave 4.1).
 * Единый источник для MapLibreMap и OpenSpec map-client-perf-density-gates.
 */

/** Последний zoom, на котором GeoJSON-источник ещё строит кластеры (clusterMaxZoom). */
export const CLUSTER_SOURCE_MAX_ZOOM = 14;

/**
 * Ниже — слои кластеров; >= — MVT объектов.
 * Должно быть CLUSTER_SOURCE_MAX_ZOOM + 1.
 */
export const CLUSTER_MVT_SWITCH_ZOOM = CLUSTER_SOURCE_MAX_ZOOM + 1;

/**
 * Ниже — не запрашивать и не рисовать work-items на viewport
 * (снижение плотности на обзорных зумах).
 */
export const WORK_ITEMS_MIN_ZOOM = 12;

/**
 * Wave 1.6 / fix stability: ниже — callouts не строим.
 * 13 — раньше порога MVT (15), чтобы подписи работали на якорях cluster GeoJSON.
 */
export const CALLOUTS_MIN_ZOOM = 13;

/** Максимум callouts во viewport (MapLibre MVP без deck.gl). */
export const CALLOUTS_MAX_COUNT = 40;

/**
 * Wave 5.5: при числе кандидатов ≥ этого порога — deck.gl TextLayer + CollisionFilter.
 * Ниже — MapLibre GeoJSON callouts (лимит CALLOUTS_MAX_COUNT).
 */
export const CALLOUTS_DECK_MIN_COUNT = CALLOUTS_MAX_COUNT + 1;

/** Максимум якорей для deck path во viewport (collision режет визуальный шум). */
export const CALLOUTS_DECK_MAX_COUNT = 250;
